import { render } from "./ImportantPage.vue?vue&type=template&id=dc178eac&ts=true"
import script from "./ImportantPage.vue?vue&type=script&lang=ts"
export * from "./ImportantPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__